import React, { useEffect, useState } from "react";
import { CCard, CCardBody, CCardHeader, CCol, CRow } from "@coreui/react";

import CustomWidgetProgress from "./CustomWidgetProgress";
import Auth from "src/auth";
import { apiCallSPGet } from "src/_apiConfig/apiCall";

const DFONotification = () => {
  const { authenticated } = Auth();
  const [userData, setUserData] = useState([]);
  useEffect(() => {
    getNotificatinDFOList();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  const getNotificatinDFOList = async () => {
    if (authenticated) {
      setUserData([]);

      await apiCallSPGet(
        `Notification/DFO?userId=${authenticated.userId}&districtId=${authenticated.district}`
      ).then((res) => {
        if (res.success) setUserData(res.data);
      });
    }
  };
  const data = [
    {
      color: "success",
      header: userData?.dfoabsbgPayment,
      text: "Access Benefit Sharing BG Payment ",
      onClick: "/ABSbankguaranteelist",
      footer: "",
    },
    {
      color: "info",
      header: userData?.dfoAdHocPaymentClarificationMe,
      text: "AdHoc Payment - Clarification ",
      onClick: "lot/adhocpayment/type/4",
      footer: "",
    },
  ];

  const dataLotDetails = [
    // {
    //   color: "info",
    //   header: userData?.dfoAgreementLatterSigned,
    //   text: "Agreement Latter Signed",
    //   onClick: "/lotlist/1",
    //   footer: "",
    // },
    // {
    //   color: "info",
    //   header: userData?.dfoAdjustFinalInstallmentAmount,
    //   text: "Adjust Final Installment Amount",
    //   onClick: "/lotlist/2",
    //   footer: "",
    // },
  ];

  return (
    <CRow>
      <CCol xs="12">
        <CCard class="dashboard HO">
          <CCardHeader>
             <CRow>
                          <CCol>
                            <div >
                         <br></br>
                             <marquee style={{ color: 'red', fontWeight: 'bold', fontSize: '18px', Height:'50px' }}>Important Note: Our website will undergo scheduled maintenance and will be unavailable for approximately 7 hours starting from 20th February 2026 at 05:30 PM onwards.</marquee>
                      </div> 
                          </CCol>
                        </CRow>
            <CRow className="pt-3 ">
              <CCol>
                {/* <h3>CCF Home</h3> */}
                <h3>Notification</h3>
              </CCol>
            </CRow>
          </CCardHeader>
          <CCardBody>
            <CRow className="pt-3 ">
              {data.map((item, index) => (
                <CustomWidgetProgress item={item} index={index} />
              ))}
            </CRow>
            <CRow className="pt-3 ">
              {dataLotDetails.map((item, index) => (
                <CustomWidgetProgress item={item} index={index} />
              ))}
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  );
};

export default DFONotification;
